import React from "react";
import { Box, Typography, Grid, Paper, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
// import MapSection from "../../components/farm_overview/sections/MapSection";
import SummaryCard from "../../components/farm_overview/sections/SummaryCard";
import UpcomingTasks from "../../components/farm_overview/sections/UpcomingTasks";
import WeatherWidget from "../../components/farm_overview/sections/WeatherWidget";
import ChartsSection from "../../components/farm_overview/sections/ChartsSection";
import ActivityFeed from "../../components/farm_overview/sections/ActivityFeed";
import GardenCard from "../../components/farm_overview/GardenCard";

const FarmOverview = () => {
  const gardenData = [
    {
      id: 1,
      imgsrc: "../../assets/images/trending-now/apple-smartwatch.jpg",
      name: "Garden A",
      latitude: 0.3476,
      longitude: 32.5825,
      location: "Kampala, Uganda",
      crop: "Maize",
      area: 20,
      status: "Planted",
      users: [
        { name: "John Doe", imgsrc: "/path/to/image1.jpg" },
        { name: "Jane Smith", imgsrc: "/path/to/image2.jpg" },
        { name: "Jane Smith", imgsrc: "/path/to/image2.jpg" },
      ],
    },
    {
      id: 2,
      imgsrc: "/path/to/image2.jpg",
      name: "Garden B",
      latitude: 0.3121,
      longitude: 32.5811,
      location: "Entebbe, Uganda",
      crop: "Onions",
      area: 10,
      status: "Planted",

      users: [
        { name: "Alice Johnson", imgsrc: "/path/to/image3.jpg" },
        { name: "Bob Brown", imgsrc: "/path/to/image4.jpg" },
      ],
    },

    {
      id: 3,
      imgsrc: "/path/to/image3.jpg",
      name: "Garden C",
      latitude: 0.3476,
      longitude: 32.5825,
      location: "Kampala, Uganda",
      crop: "Tomatoes",
      area: 15,
      status: "Harvested",
      users: [
        { name: "Charlie Green", imgsrc: "/path/to/image5.jpg" },
        { name: "Diana Prince", imgsrc: "/path/to/image6.jpg" },
      ],
    },
  ];

  const summaryData = [
    { title: "Total Workers", value: 24, icon: "mdi:account-group" },
    { title: "Total Gardens", value: 8, icon: "mdi:tree-outline" },
    { title: "Total Area", value: "150 acres", icon: "mdi:map" },
    { title: "Monthly Yield", value: "12 tons", icon: "mdi:barley" },
  ];

  const rows = [
    { id: 1, name: "Garden A", crop: "Maize", area: 20, status: "Planted" },
    {
      id: 2,
      name: "Garden B",
      crop: "Tomatoes",
      area: 15,
      status: "Harvested",
    },
    { id: 3, name: "Garden C", crop: "Onions", area: 10, status: "Planted" },
  ];

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Farm Overview</Typography>
        <Box>
          <Button size="small" variant="contained" sx={{ mr: 2, fontSize: 14 }}>
            Add New Garden
          </Button>
        </Box>
      </Box>

      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3.5}>
        <Box gridColumn={{ xs: "span 12" }}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            }}
            gap={3}
          >
            {summaryData.map((item) => (
              <SummaryCard key={item.id} {...item} />
            ))}
          </Box>
        </Box>
      </Box>

      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3.5}>
        <Box gridColumn={{ xs: "span 12" }}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            }}
            gap={3}
          >
            {gardenData.map((garden) => (
              <GardenCard key={garden.id} garden={garden} />
            ))}
          </Box>
        </Box>
      </Box>

      <Grid container spacing={2} mt={3}>
        <Grid item xs={12} md={4}>
          <Typography variant="h6" mb={1}>
            Upcoming Tasks
          </Typography>
          <Paper elevation={1}>
            <UpcomingTasks />
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={3}>
        <Grid item xs={12} md={4}>
          <WeatherWidget />
        </Grid>
        <Grid item xs={12} md={8}>
          <ActivityFeed />
        </Grid>
      </Grid>

      <Box mt={4}>
        <Typography variant="h6">Production Trends</Typography>
        <Paper elevation={1} sx={{ mt: 1, p: 2 }}>
          <ChartsSection />
        </Paper>
      </Box>

      <Box mt={4}>
        <Typography variant="h6">Farm Map</Typography>
        <Paper elevation={2} sx={{ height: 400, mt: 1 }}>
          {/* <MapSection gardens={gardenData} /> */}
        </Paper>
      </Box>
    </Box>
  );
};

export default FarmOverview;
